











































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  VideoData, emptyData, getInfo, putData, postData
} from '@/api/videoDevice/index'
import { getDDLItem } from '@/configs/functions'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import { DDLItem } from '@/api/common/select'
import Element from 'element-ui'
import { PopUnitData } from '@/api/heritageUnit/heritageUnit'
import VideoPointList from '@/components/videoDevice/form/point/list.vue'
import PageForm from '@/components/pageLayout/form.vue'
import UnitSearchForm from '@/components/heritageUnit/search/index.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    UnitName: [{ required: true, message: '请选择文保单位' }],
    DeviceName: [
      { required: true, message: '请输入设备名称', trigger: 'blur' }
    ],
    DeviceModel: [
      { required: true, message: '请输入设备型号', trigger: 'blur' }
    ],
    DeviceNumber: [
      { required: true, message: '请输入设备编号', trigger: 'blur' }
    ],
    SerialNumber: [
      { required: true, message: '请输入设备序列号', trigger: 'blur' }
    ],
    DriverName: [
      { required: true, message: '请输入设备驱动', trigger: 'blur' }
    ],
    DriverVersion: [
      { required: true, message: '请输入驱动版本', trigger: 'blur' }
    ],
    UniqueCoding: [
      { required: true, message: '请输入资源唯一编码', trigger: 'blur' }
    ],
    Manufacturer: [
      { required: true, message: '请输入厂商', trigger: 'blur' }
    ],
    ProtocolId: [
      {
        required: true,
        validator: validateIntKey('请选择视频接入协议'),
        trigger: 'change'
      }
    ],
    AccessIp: [
      { required: true, message: '请输入访问IP', trigger: 'blur' }
    ],
    AccessPort: [
      { required: true, message: '请输入端口', trigger: 'blur' }
    ],
    AccessUser: [
      { required: true, message: '请输入访问帐号', trigger: 'blur' }
    ],
    AccessPwd: [
      { required: true, message: '请输入访问密码', trigger: 'blur' }
    ],
  }
}

@Component({
  components: {
    PageForm, UnitSearchForm, VideoPointList
  }
})
export default class VideoForm extends Vue {
  public collapseNames: string[] = ['base', 'points']

  public form: VideoData = Object.assign({}, emptyData)
  public loading = false

  public protocolList: DDLItem[] = []
  public brandList: DDLItem[] = []
  public driverList: DDLItem[] = []
  public statusList: DDLItem[] = []
  public rules = getFormRules(0, this.form)

  // dynamic component
  public $refs!: {
    formCtrl: PageForm
    pointsCtrl: VideoPointList
    unitSearchCtrl: UnitSearchForm
  }
  public setCtrlsData() {
    /*
      关于 ref 注册时间的重要说明：
      因为 ref 本身是作为渲染结果被创建的，在初始渲染的时候你不能访问它们 - 它们还不存在！
      $refs 也不是反馈式的，因此你不应该试图用它在模板中做数据绑定
      使用 this.$nextTick(() => {}) 等页面渲染好再调用
      */
    this.$nextTick(() => {
      if (this.$refs.pointsCtrl) {
        this.$refs.pointsCtrl.videoId = this.form.Id
        this.$refs.pointsCtrl.loadData()
      }
    })
  }
  public getCtrlsData() {
    if (this.$refs.pointsCtrl) {
      this.form.PointList = this.$refs.pointsCtrl.getData()
    }
  }
  public mounted() {
    window.eventBus.$on('submitUnitSearchForm', (data: PopUnitData[]) => {
      this.getUnit(data[0])
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitUnitSearchForm')
  }
  //#region 弹窗查询文保单位
  public openUnitSearch() {
    window.eventBus.$emit('openUnitSearchForm')
  }
  public getUnit(info: PopUnitData) {
    this.form.UnitId = info.UnitId
    this.form.UnitName = info.UnitName
    this.form.UnitCode = info.UnitCode
    this.$refs.formCtrl.validateField('UnitName')
  }
  public closeUnitSearch() {
    console.log("这里是查询文保单位组件关闭后回传的事件")
  }
  public delUnit() {
    this.form.UnitId = 0
    this.form.UnitName = ''
    this.form.UnitCode = ''
    this.$refs.formCtrl.validateField('UnitName')
  }
  //#endregion
  public created() {
    this.fetchSource()
    this.fetchData()
  }
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.protocolList = data.protocolList
    }
  }
  public get isSDK(): boolean {
    var sdk = false
    if (this.form.ProtocolId > 0) {
      var item = getDDLItem(this.protocolList, this.form.ProtocolId)
      sdk = item.ExInfo.Flag1
    }
    return sdk
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchVideo(id)
  }
  public fetchVideo(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.rules = getFormRules(this.form.Id, this.form)
      if (this.form.Id == 0) {
        this.$refs.formCtrl.clearValidate()
      } else {
        this.$nextTick(() => {
          this.setCtrlsData()
        })
      }
      this.loading = false
    })
  }
  public onCancel() {
    this.$router.push({ path: '/VideoList' })
  }
  public onSubmit() {
    this.getCtrlsData()
    const promist =
      this.form.Id > 0
        ? putData(this.form.Id, this.form)
        : postData(this.form)
    promist.then((response: { data: any }) => {
      const data = response.data
      const msg = this.form.Id > 0 ? '保存' : '创建'
      if (data && !data.IsError) {
        // this.$message({
        //   message: `${msg}成功`,
        //   type: 'success'
        // })
        this.$message.warning(`${msg}成功`)
        this.$router.push({ path: '/VideoList' })
      } else {
        this.$message.warning({
          dangerouslyUseHTMLString: true, message: `${data.Message}`
        })
        console.log(response)
      }
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
